import React from "react";
import PropTypes from "prop-types";

const ButtonIcon = ({ icon, alt, className }) => {
  if (!icon) return null;
  return (
    <img
      src={icon}
      alt={alt || "icon"}
      className={`inline-block align-middle mr-2 h-4 w-4 object-contain ${className || ""}`}
    />
  );
};

ButtonIcon.propTypes = {
  icon: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default ButtonIcon;
